<a
  class="big-card"
  [routerLink]="content | slug"
  (click)="triggerViewItem(content)">
  <div class="big-card__header">
    <small
      class="semibold"
      sharryEllipsisTooltip
      >{{ content.subtitle | uppercase }}</small
    >
    <p
      class="big-card__header__title bold"
      sharryEllipsisTooltip="2">
      {{ content.title }}
    </p>
    <small
      [ngStyle]="{ opacity: !content.nextUpcomingVariant?.discount ? 0 : 1 }"
      class="big-card__header__label big-card__header__label--{{ content.nextUpcomingVariant?.discount?.kind }}"
      >{{ 'content-card.' + content.nextUpcomingVariant?.discount?.kind | i18next }}</small
    >
    <p class="big-card__header__date-duration">
      @if ([$any(content).nextUpcomingVariant] | variantDate) {
        {{ [$any(content).nextUpcomingVariant] | variantDate | date: 'd MMM yyyy'
        }}{{ content?.variantDuration?.duration ? '&nbsp;-' : null }}
      }
      @if (content?.variantDuration?.duration) {
        {{ content.variantDuration.duration }}&nbsp;{{ content.variantDuration.durationType | i18next }}
      }
    </p>
    <div>
      <span class="bold big-card__header__title--gold">
        {{
          'shop.big-card.price'
            | i18next
              : {
                  price: content.nextUpcomingVariant?.discountedPrice | currency: 'EUR' : 'symbol-narrow',
                }
        }}
      </span>
      @if (content.nextUpcomingVariant?.discount) {
        <span class="big-card__header__old-price">
          {{ content.nextUpcomingVariant?.price | currency: 'EUR' : 'symbol-narrow' }}
        </span>
      }
    </div>
  </div>
  <picture class="big-card__image">
    <img
      alt="service-image"
      loading="lazy"
      [src]="content.coverPicture?.bestVersion?.url"
  /></picture>
</a>
